<template>
  <v-card
    v-intersect="read"
    color="special"
    class="notification-card mb-3"
    @click="$emit('navigateto', notificationType, appointmentId, billId)"
  >
    <v-chip
      v-if="!notificationRead"
      small
      rounded
      color="primary"
      class="font-weight-bold white--text new-chip"
      >{{ $t("notificationsCenter.notificationCard.chipLabel") }}</v-chip
    >
    <v-card-title class="pa-0 card-text-color">
      <img
        v-if="isAnInternalIcon()"
        :src="require('@/assets/icons/'.concat(getIcon))"
        alt=""
        width="24px"
        class="mr-2"
      />
      <v-icon v-else left large class="mr-2" color="primary">{{
        getIcon
      }}</v-icon>
      <span class="title font-weight-bold"> {{ getTitle }} </span>
    </v-card-title>
    <v-card-title class="pa-0 card-text-color">
      <p class="text-uppercase mb-1">
        {{ notification.creationDate | date("ddd DD MMMM YYYY - HH:mm") }}
      </p>
    </v-card-title>
    <v-card-text class="pa-0 card-text-color">
      <p class="body-2 font-weight-medium mb-0" v-html="getText"></p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["notification"],
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.getters["login/userInfo"];
    },
    notificationId() {
      if (this.notification?.notificationId) {
        return this.notification.notificationId;
      }
      return null;
    },
    notificationType() {
      if (this.notification?.hfUserNotificationType) {
        return this.notification.hfUserNotificationType;
      }
      return null;
    },
    notificationAction() {
      if (this.notification?.notificationAction) {
        return this.notification.notificationAction;
      }
      return null;
    },
    notificationRead() {
      return this.notification.read;
    },
    appointmentId() {
      if (this.notification?.appointmentId) {
        return this.notification.appointmentId;
      }
      return null;
    },
    iupCode() {
      if (this.notification?.iupCode) {
        return this.notification.iupCode;
      }
      return null;
    },
    billId() {
      if (this.notification?.billId) {
        return this.notification.billId;
      }
      return null;
    },
    billProtocolCode() {
      if (this.notification?.billProtocolCode) {
        return this.notification.billProtocolCode;
      }
      return null;
    },
    officeId() {
      if (this.notification?.officeId) {
        return this.notification.officeId;
      }
      return null;
    },
    officeName() {
      if (this.notification?.officeName) {
        return this.notification.officeName;
      }
      return null;
    },
    memberCodiceFiscale() {
      if (this.notification?.memberCodiceFiscale) {
        return this.notification.memberCodiceFiscale;
      }
      return null;
    },
    feUser() {
      if (this.notification?.feUser) {
        if (
          this.notification.feUser.userName &&
          this.notification.feUser.userSurname
        ) {
          return this.notification.feUser.userName
            .concat(" ")
            .concat(this.notification.feUser.userSurname);
        }
      }
      return null;
    },
    portal() {
      if (this.notification?.portal) {
        return this.notification.portal;
      }
      return null;
    },
    getIcon() {
      let icons = {
        APPOINTMENT: "event_repeat",
        BILL: "file-circle-euro-solid-primary.svg"
      };
      return icons[this.notificationType];
    },
    getTitle() {
      let str = `${this.portal}_${this.notificationType}_${this.notificationAction}`;
      return this.$t(`notificationsCenter.title.${str}`);
    },
    getText() {
      let str = `${this.portal}_${this.notificationType}_${this.notificationAction}`;
      let notifText = this.$t(`notificationsCenter.text.${str}`);
      let params = {
        fiscalCode: this.memberCodiceFiscale,
        iupCode: this.iupCode,
        feUser: this.feUser,
        protocolCode: this.billProtocolCode
      };
      for (let prop in params) {
        notifText = notifText.replace(
          new RegExp("{" + prop + "}", "g"),
          params[prop]
        );
      }
      return notifText;
    }
  },
  methods: {
    read(entries, observer) {
      if (!this.notificationRead) {
        if (entries[0].isIntersecting) {
          this.$store.dispatch("notifications/markAsRead", this.notificationId);
        }
      }
    },
    isAnInternalIcon() {
      return this.getIcon.endsWith(".svg");
    }
  }
};
</script>

<style scoped>
.notification-card {
  position: relative;
  padding: 15px !important;
  border-radius: 2px;
  box-shadow: unset;
  color: white !important;
  cursor: pointer;
  height: 100%;
}
.notification-card .v-card__title > p {
  font-size: 14px;
}
.new-chip {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 65px;
  height: 23px;
}
</style>
